// روابط الفوتر. صفحات `/pages/…` تُكتب نصوصها وعناوينها من «واجهة المتجر»
// في لوحة الأدمن، والفوتر يأخذ عنوانها من هناك.
const links = {
  customerServices: [
    { label: 'البحث برقم الهيكل', path: '/catalog/vin' },
    { label: 'كتالوج القطع', path: '/catalog' },
    { label: 'الشحن والتوصيل', path: '/pages/shipping' },
    { label: 'الإرجاع والاستبدال', path: '/pages/returns' },
  ],
  about: [
    { label: 'عن المنصة', path: '/pages/about' },
    { label: 'دليل الاستخدام', path: '/guide' },
    { label: 'الشروط والأحكام', path: '/pages/terms' },
    { label: 'سياسة الخصوصية', path: '/pages/privacy' },
    { label: 'حذف الحساب', path: '/delete-account' },
  ],
};

export default links;
